export default function () {
  return [
    {
      name: 'Styczeń',
      id: '1'
    },
    {
      name: 'Luty',
      id: '2'
    },
    {
      name: 'Marzec',
      id: '3'
    },
    {
      name: 'Kwiecień',
      id: '4'
    },
    {
      name: 'Maj',
      id: '5'
    },
    {
      name: 'Czerwiec',
      id: '6'
    },
    {
      name: 'Lipiec',
      id: '7'
    },
    {
      name: 'Sierpień',
      id: '8'
    },
    {
      name: 'Wrzesień',
      id: '9'
    },
    {
      name: 'Październik',
      id: '10'
    },
    {
      name: 'Listopad',
      id: '11'
    },
    {
      name: 'Grudzień',
      id: '12'
    },
  ];
}
